import React, { forwardRef } from 'react'
import { Icon } from '@manychat/manyui'

import cm from './styles.module.css'

export const TypingDots = forwardRef<HTMLLIElement>((_, ref) => (
  <li ref={ref} className={cm.wrapper}>
    <div className={cm.avatar} aria-hidden>
      <Icon.Ai size={20} />
    </div>

    <p className={cm.dots}>
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </p>
  </li>
))

TypingDots.displayName = 'TypingDots'
